import { WebsocketShippingProviderPublishProgress } from "@intelligems/ig-types/functions/meta/web-socket/shipping-provider";
import { QueryClient } from "@tanstack/react-query";

import { shippingProviderKeys } from "../api/queryKeys";

/**
 * On a successful publish-job completion the provider's active version and
 * version history have changed server-side. Invalidate the provider GET and
 * versions so any mounted view (the Modifications-page status card, the
 * workspace) refreshes — even when the publish finished after the workspace
 * overlay closed, since that one-shot subscription's terminal frame is no
 * longer guaranteed to reach the (now-unmounted) workspace listener.
 *
 * The publish-job subscription is per-connection on the shared org socket and
 * outlives the workspace, so the always-mounted `WebsocketProvider` that calls
 * this still receives the terminal frame. Only `succeeded` changes the active
 * version; non-terminal and failed frames are ignored.
 */
export function handleShippingProviderPublishProgress(
  message: WebsocketShippingProviderPublishProgress,
  queryClient: QueryClient
) {
  if (message.jobStatus !== "succeeded") {
    return;
  }
  void queryClient.invalidateQueries({
    queryKey: shippingProviderKeys.one(message.experienceId),
  });
  void queryClient.invalidateQueries({
    queryKey: shippingProviderKeys.versions(message.experienceId),
  });
}
